import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Cpu = createReactComponent("Cpu", ["svg", defaultAttributes, [["rect", {
  x: "4",
  y: "4",
  width: "16",
  height: "16",
  rx: "2",
  ry: "2",
  key: "15ziuw"
}], ["rect", {
  x: "9",
  y: "9",
  width: "6",
  height: "6",
  key: "bgbeli"
}], ["line", {
  x1: "9",
  y1: "1",
  x2: "9",
  y2: "4",
  key: "1qmpe9"
}], ["line", {
  x1: "15",
  y1: "1",
  x2: "15",
  y2: "4",
  key: "3eqc0l"
}], ["line", {
  x1: "9",
  y1: "20",
  x2: "9",
  y2: "23",
  key: "1uyze4"
}], ["line", {
  x1: "15",
  y1: "20",
  x2: "15",
  y2: "23",
  key: "111a3f"
}], ["line", {
  x1: "20",
  y1: "9",
  x2: "23",
  y2: "9",
  key: "1xzigm"
}], ["line", {
  x1: "20",
  y1: "14",
  x2: "23",
  y2: "14",
  key: "1strci"
}], ["line", {
  x1: "1",
  y1: "9",
  x2: "4",
  y2: "9",
  key: "fyl7h1"
}], ["line", {
  x1: "1",
  y1: "14",
  x2: "4",
  y2: "14",
  key: "kued05"
}]]]);
export default Cpu;